import { cn } from "../../../utils/class-names";
import { KeyValueList } from "../../key-value-list";
import { getDebtRewardsStateColor } from "../utils";
import {
  asPercent,
  getDebtAprMetrics,
  getDisplayCollateralYields,
} from "@silo/utils";
import { BreakdownDebt } from "../breakdown/breakdown-debt";
import { DebtAprAsset } from "@silo/types";

export interface PositionDebtProps {
  className?: string;
  asset: DebtAprAsset;
  nativeRewardsSymbol: string;
}

export function PositionDebt({
  className,
  asset,
  nativeRewardsSymbol,
}: PositionDebtProps): JSX.Element {
  const { isDebtAprFixed, debtBaseApr, depositMode } = asset;

  const {
    debtRewardsState,
    totalDebtApr,
    hasDebtRewards,
    debtRewards,
    showFixedLabel,
  } = getDebtAprMetrics(asset, nativeRewardsSymbol);

  const displayCollateralYields = getDisplayCollateralYields(depositMode);
  const showTotalDebtApr = displayCollateralYields || totalDebtApr > 0n;

  return (
    <div className={cn("flex flex-col", className)}>
      <KeyValueList.Pair>
        <KeyValueList.Key>APR</KeyValueList.Key>

        <KeyValueList.Value
          dataCy="apy"
          className={cn(
            "flex flex-col items-end font-mono font-medium text-white",
            isDebtAprFixed ? "text-amber-300" : "",
            getDebtRewardsStateColor(debtRewardsState)
          )}
        >
          <div data-cy="apy">
            {showTotalDebtApr ? asPercent(totalDebtApr) : "--"}
          </div>

          {showFixedLabel && <div className="font-sans text-sm">Fixed</div>}
        </KeyValueList.Value>
      </KeyValueList.Pair>

      {hasDebtRewards && (
        <BreakdownDebt
          className="gap-0 text-sm"
          align="right"
          debtBaseApr={debtBaseApr}
          debtRewards={debtRewards}
          isDebtAprFixed={isDebtAprFixed}
        />
      )}
    </div>
  );
}
